import { createStore } from "redux";
import reducers from "./reducers";
import storeEnhancer from "./enhancer";

const initialStoreState = {};
export default () => createStore(reducers, initialStoreState, storeEnhancer);
